import gql from 'graphql-tag';

export const getUser = gql`
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      registered
      userConversations {
        items {
          id
          name
          status
          conversation {
            id
            name
            createdAt
            associated {
              items {
                convoLinkUserId
                user {
                  id
                  username
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getConversationsList = gql`
  query GetConversationsList($id: ID!) {
    getUser(id: $id) {
      userConversations {
        items {
          name
          id
          conversation {
            id
          }
        }
      }
    }
  }
`;

export const getConvo = gql`
  query GetConvo($id: ID!, $limit: Int, $nextToken: String) {
    getConvo(id: $id) {
      id
      messages(sortDirection: DESC, limit: $limit, nextToken: $nextToken) {
        nextToken
        items {
          id
          content
          createdAt
          owner
          chatbot
          isSent
          file {
            bucket
            region
            key
          }
          messageConversationId
          conversation {
            id
            name
            createdAt
          }
        }
      }
    }
  }
`;

export const searchMessages = gql`
  query SearchMessages(
    $filter: SearchableMessageFilterInput
    $sort: SearchableMessageSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchMessages(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        createdAt
        owner
        chatbot
        isSent
        file {
          bucket
          region
          key
        }
        messageConversationId
        conversation {
          id
          name
          createdAt
        }
      }
      nextToken
    }
  }
`;
export const searchUsers = gql`
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        registered
        userConversations {
          items {
            id
            name
            status
            convoLinkUserId
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const searchConvoLinks = gql`
  query SearchConvoLinks(
    $filter: SearchableConvoLinkFilterInput
    $sort: SearchableConvoLinkSortInput
    $limit: Int
    $nextToken: Int
  ) {
    searchConvoLinks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        status
        convoLinkUserId
        user {
          id
          username
          registered
        }
        conversation {
          id
          name
          createdAt
        }
      }
      nextToken
    }
  }
`;

export const randomUserUuid = gql`
  query RandomUserUuid {
    randomUserUuid
  }
`;

export const getAdminChatTag = gql`
  query getAdminChatTag($siteId: ID!) {
    getAdminChatTagdataIntlchtbhv(siteId: $siteId){
      siteId 
      contant 
      chatTagType 
      ownerId 
      createdAt 
      updatedAt
    }
  }
`;

export const getBillboardLyrics = gql`
  query GetBillboardLyrics($siteId: String!, $slugTerm: String!) { 
    getBillboardLyrics(siteId: $siteId, slugTerm: $slugTerm){
      siteId
	    slugTerm
	    artist
	    decade
	    lyrics
	    Mixed
	    Negative
	    Neutral
	    Positive
	    rank
	    song
	    source
	    Year
    }
  }
`;

export const GetRoraySite = gql` 
  query getRoraySite($siteId: String!, $typeValue: String!) { 
    getRoraySiteN4udipg3snevddjjskvzzepdhaJcdev(siteId: $siteId, typeValue: $typeValue) { 
      siteId  
      typeValue  
      content  
      active  
      order  
      slugTitle  
      title  
      __typename  
      createdAt  
      updatedAt  
    } 
  } 
`;

export const getAmzHeros = gql`query GetAmzHeros($siteId: String!, $slugTerm: ID!) {
  getAmzHeros(siteId: $siteId, slugTerm: $slugTerm) {
    slugTerm
    siteId
    term
    source
    category
    city
    connectLink
    content
    designation
    imageUrl
    since
    createdAt
    updatedAt
  }
}
`;
export const listAmzHeross = gql`query ListAmzHeross(
  $filter: TableAmzHerosFilterInput, 
  $limit: Int, 
  $nextToken: String
) {
  listAmzHeros(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      slugTerm
      siteId
      term
      source
      category
      city
      connectLink
      content
      designation
      imageUrl
      since
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;

export const getBotInformations = gql`query ListBotInformations(
  $filter: TableBotInformationFilterInput
  $limit: Int
  $nextToken: String
) {
  listBotInformations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      botName
      dynamoDBDocument
      lambdaFunctionName
      url
      description
      feature
      radioName
      appSync
      amplify
      codeCommit
      CloudFormation
      tableBot
      Notes
      Related {
        name
        link
      }
      Groups
      Sponsored {
        name
        link
      }
      BotLogo
      BotDisplayName
    }
    nextToken
  }
}
`;

export const listAdminPermissionss = gql`query ListAdminPermissionss(
  $filter: TableAdminPermissionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminPermissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      roleName
      read
      write
      listing
      channels
      members
      messages
      Permissions
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;

export const listConversationStarters = `query ListConversationStarters(
  $filter: TableConversationStarterFilterInput
  $limit: Int
  $nextToken: String
) {
  listConversationStarters(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      botname
      conversationStarter {
        key
        value
      }
    }
    nextToken
  }
}
`;
